import { motion } from 'framer-motion';

export default function Privacy() {
  return (
    <div className="bg-ivory pt-32 min-h-screen" data-testid="privacy-page">
      <section className="pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <motion.p
            className="font-body text-xs uppercase tracking-[0.3em] text-champagne mb-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            Legale
          </motion.p>
          <motion.h1
            className="font-heading text-4xl md:text-5xl text-night tracking-tight mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            data-testid="page-title"
          >
            Privacy Policy
          </motion.h1>
          
          <div className="prose prose-stone max-w-none">
            <p className="font-body text-stone-500 italic leading-relaxed mb-8">
              Informativa sul trattamento dei dati personali ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679
            </p>
            
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              La presente informativa è resa ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679 del Parlamento Europeo e del Consiglio del 27 aprile 2016 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali (di seguito "GDPR") nonché della normativa nazionale applicabile, con particolare riferimento al D.Lgs. 30 giugno 2003 n.196 ("Codice in materia di protezione dei dati personali") come modificato dal D.Lgs. 101/2018.
            </p>

            <p className="font-body text-stone-600 leading-relaxed mb-6">
              La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che accedono e navigano sul sito web La Villa (di seguito anche "Sito"), nonché degli utenti che interagiscono con i servizi digitali resi disponibili tramite lo stesso.
            </p>

            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Il trattamento dei dati personali avviene nel rispetto dei principi di:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-6 ml-4">
              <li>liceità</li>
              <li>correttezza</li>
              <li>trasparenza</li>
              <li>limitazione delle finalità</li>
              <li>minimizzazione dei dati</li>
              <li>esattezza</li>
              <li>limitazione della conservazione</li>
              <li>integrità e riservatezza</li>
            </ul>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              previsti dall'art. 5 del GDPR.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">1. Ambito di Applicazione dell'Informativa</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              La presente informativa si applica ai dati personali raccolti attraverso il sito internet e tramite tutte le funzionalità e i servizi ad esso collegati.
            </p>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Tra i servizi offerti tramite il sito possono rientrare, a titolo esemplificativo e non esaustivo:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-6 ml-4">
              <li>navigazione del sito</li>
              <li>utilizzo dei moduli di contatto</li>
              <li>richieste di informazioni</li>
              <li>iscrizione a newsletter o comunicazioni informative</li>
              <li>prenotazioni di servizi o eventi</li>
              <li>acquisto di prodotti o servizi tramite il sito</li>
              <li>partecipazione ad eventi organizzati presso la struttura</li>
              <li>interazioni tramite email o strumenti digitali collegati al sito</li>
              <li>attività di analisi statistica e analisi di mercato</li>
              <li>gestione delle transazioni economiche e dei pagamenti</li>
              <li>gestione di comunicazioni commerciali e promozionali</li>
            </ul>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              La presente informativa non si applica ai siti web di terze parti eventualmente consultabili tramite link presenti nel sito.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">2. Categorie di Dati Personali Trattati</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Il sito può raccogliere e trattare diverse categorie di dati personali.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">2.1 Dati identificativi e di contatto</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Tra cui, a titolo esemplificativo:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-6 ml-4">
              <li>nome e cognome</li>
              <li>indirizzo email</li>
              <li>numero di telefono</li>
              <li>indirizzo di residenza o spedizione</li>
              <li>eventuali dati aziendali</li>
              <li>altri dati forniti volontariamente dall'utente tramite i moduli del sito</li>
            </ul>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">2.2 Dati relativi a richieste, prenotazioni e acquisti</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Possono essere trattati dati personali necessari alla gestione di:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-6 ml-4">
              <li>richieste di informazioni</li>
              <li>prenotazioni di servizi</li>
              <li>partecipazione ad eventi</li>
              <li>acquisti di prodotti o servizi</li>
              <li>richieste di preventivo</li>
            </ul>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">2.3 Dati relativi alle transazioni economiche</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Nel caso di acquisti o pagamenti effettuati tramite il sito, i pagamenti possono essere gestiti tramite provider di pagamento esterni.
            </p>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Il sito può ricevere esclusivamente dati amministrativi relativi alla transazione, quali:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-4 ml-4">
              <li>identificativo dell'ordine</li>
              <li>importo della transazione</li>
              <li>data e ora della transazione</li>
              <li>stato del pagamento</li>
              <li>metodo di pagamento utilizzato</li>
              <li>eventuali dati necessari alla fatturazione</li>
            </ul>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Il sito non memorizza né tratta direttamente dati completi relativi agli strumenti di pagamento, quali numero completo della carta di credito, codice CVV o credenziali bancarie, che vengono trattati esclusivamente dai provider di pagamento secondo i propri standard di sicurezza e nel rispetto della normativa vigente.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">2.4 Dati di navigazione</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Durante la normale navigazione del sito, i sistemi informatici acquisiscono automaticamente alcuni dati personali la cui trasmissione è implicita nell'utilizzo dei protocolli di comunicazione di Internet.
            </p>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Tra questi dati possono rientrare:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-4 ml-4">
              <li>indirizzo IP</li>
              <li>identificativi del dispositivo</li>
              <li>tipo di browser utilizzato</li>
              <li>sistema operativo</li>
              <li>data e ora della richiesta</li>
              <li>pagine visitate</li>
              <li>tempo di permanenza sul sito</li>
              <li>percorso di navigazione</li>
              <li>informazioni relative all'interazione con i contenuti del sito</li>
            </ul>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Tali informazioni non sono raccolte per essere associate a interessati identificati, ma potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi, permettere l'identificazione degli utenti.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">3. Finalità del Trattamento</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              I dati personali raccolti tramite il sito possono essere trattati per le seguenti finalità.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">3.1 Funzionamento del sito e sicurezza informatica</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Garantire il corretto funzionamento tecnico del sito, prevenire accessi non autorizzati e garantire la sicurezza dei sistemi informatici.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">3.2 Gestione delle richieste degli utenti</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Gestire e rispondere alle richieste di informazioni, contatti o comunicazioni inviate dagli utenti.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">3.3 Gestione di prenotazioni, servizi ed eventi</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Consentire la gestione operativa di prenotazioni, servizi o eventi organizzati dalla struttura.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">3.4 Gestione degli acquisti e delle transazioni</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Gestire contratti di acquisto relativi a prodotti o servizi offerti tramite il sito.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">3.5 Adempimenti legali e fiscali</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Adempiere agli obblighi previsti dalla normativa fiscale, contabile e amministrativa.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">3.6 Analisi statistiche e analisi di mercato</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Analizzare l'utilizzo del sito e migliorare i servizi offerti.
            </p>

            <h3 className="font-heading text-xl text-night mt-6 mb-3">3.7 Attività di marketing</h3>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Previo consenso dell'utente, inviare comunicazioni informative e promozionali relative a:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-6 ml-4">
              <li>eventi</li>
              <li>promozioni</li>
              <li>offerte commerciali</li>
              <li>aggiornamenti sulle attività della struttura</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">4. Titolare del Trattamento</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Il Titolare del trattamento dei dati personali raccolti tramite il sito è:
            </p>
            <div className="bg-stone-100 p-6 rounded-lg mb-6">
              <p className="font-heading text-lg text-night mb-2">NEMESIS S.R.L.</p>
              <p className="font-body text-stone-600 text-sm mb-1">Società a Responsabilità Limitata</p>
              <p className="font-body text-stone-600 text-sm mb-1">Codice Fiscale / Partita IVA: 04214330369</p>
              <p className="font-body text-stone-600 text-sm mb-1">Numero REA: MO – 452334</p>
              <p className="font-body text-stone-600 text-sm mb-3">Camera di Commercio: Modena</p>
              <p className="font-body text-stone-600 text-sm mb-1"><strong>Sede legale:</strong></p>
              <p className="font-body text-stone-600 text-sm mb-1">Via Emilia Est 85/B</p>
              <p className="font-body text-stone-600 text-sm mb-3">41013 – Castelfranco Emilia (MO), Italia</p>
              <p className="font-body text-stone-600 text-sm"><strong>PEC:</strong> infonemesisrl@legalmail.it</p>
            </div>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Il Titolare determina le finalità e i mezzi del trattamento dei dati personali effettuato tramite il sito e i servizi ad esso collegati.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">5. Base Giuridica del Trattamento</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Il trattamento dei dati personali si fonda sulle seguenti basi giuridiche previste dall'art. 6 del GDPR:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-6 ml-4">
              <li>esecuzione di un contratto o di misure precontrattuali richieste dall'interessato</li>
              <li>adempimento di obblighi legali</li>
              <li>consenso espresso dell'interessato</li>
              <li>legittimo interesse del titolare alla sicurezza dei sistemi e alla gestione del sito</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">6. Modalità del Trattamento</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Il trattamento dei dati personali avviene mediante strumenti informatici e telematici nel rispetto delle misure di sicurezza previste dall'art. 32 del GDPR.
            </p>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Sono adottate misure tecniche e organizzative adeguate a garantire un livello di sicurezza adeguato al rischio.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">7. Destinatari dei Dati Personali</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              I dati personali possono essere comunicati a soggetti terzi che collaborano con il Titolare per l'erogazione dei servizi offerti tramite il sito, tra cui:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-6 ml-4">
              <li>fornitori di servizi informatici</li>
              <li>provider di hosting</li>
              <li>provider di pagamento</li>
              <li>piattaforme di ticketing</li>
              <li>consulenti fiscali e legali</li>
              <li>fornitori di servizi di marketing digitale</li>
              <li>autorità pubbliche nei casi previsti dalla legge</li>
            </ul>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">8. Periodo di Conservazione dei Dati</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              I dati personali sono conservati per il tempo strettamente necessario al raggiungimento delle finalità per cui sono stati raccolti e comunque nel rispetto dei termini previsti dalla normativa vigente.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">9. Diritti dell'Interessato</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Ai sensi degli articoli 15-22 del GDPR, gli interessati possono esercitare i seguenti diritti:
            </p>
            <ul className="list-disc list-inside font-body text-stone-600 space-y-1 mb-4 ml-4">
              <li>diritto di accesso</li>
              <li>diritto di rettifica</li>
              <li>diritto alla cancellazione</li>
              <li>diritto alla limitazione del trattamento</li>
              <li>diritto alla portabilità dei dati</li>
              <li>diritto di opposizione</li>
            </ul>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Le richieste possono essere inviate al Titolare del trattamento ai recapiti indicati nella presente informativa.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">10. Diritto di Reclamo</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Gli interessati hanno il diritto di proporre reclamo all'Autorità Garante per la protezione dei dati personali ai sensi dell'art. 77 del GDPR.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">11. Cookie</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-4">
              Il sito utilizza cookie tecnici e, ove previsto, cookie analitici o di marketing.
            </p>
            <p className="font-body text-stone-600 leading-relaxed mb-6">
              Maggiori informazioni sono disponibili nella <a href="/cookie" className="text-champagne hover:underline">Cookie Policy</a> del sito.
            </p>

            <h2 className="font-heading text-2xl text-night mt-10 mb-4">12. Modifiche alla Presente Informativa</h2>
            <p className="font-body text-stone-600 leading-relaxed mb-8">
              La presente informativa può essere aggiornata nel tempo per adeguarsi a eventuali modifiche normative o tecniche. Eventuali aggiornamenti saranno pubblicati su questa pagina.
            </p>

            <div className="border-t border-stone-200 pt-8 mt-8">
              <p className="font-heading text-lg text-night">La Villa</p>
              <p className="font-body text-stone-500">Castelfranco Emilia – Modena</p>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 lg:hidden" />
    </div>
  );
}
